import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper.tsx'

const renderIcon = (color: string) => (
    <path
        d="M12.75 15C12.75 13.7574 11.0711 12.75 9 12.75C6.92893 12.75 5.25 13.7574 5.25 15M15.75 12.7503C15.75 11.8276 14.8244 11.0347 13.5 10.6875M2.25 12.7503C2.25 11.8276 3.17557 11.0347 4.5 10.6875M13.5 7.67708C13.9603 7.26509 14.25 6.66637 14.25 6C14.25 4.75736 13.2426 3.75 12 3.75C11.4237 3.75 10.8981 3.96664 10.5 4.32292M4.5 7.67708C4.03969 7.26509 3.75 6.66637 3.75 6C3.75 4.75736 4.75736 3.75 6 3.75C6.57627 3.75 7.10193 3.96664 7.5 4.32292M9 10.5C7.75736 10.5 6.75 9.49264 6.75 8.25C6.75 7.00736 7.75736 6 9 6C10.2426 6 11.25 7.00736 11.25 8.25C11.25 9.49264 10.2426 10.5 9 10.5Z"
        stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
)

export const UserGroups: React.FC<IconProps> = ({color, size}) => (
    <IconWrapper viewBox={'0 0 18 18'} {...{size, color, renderIcon}} />
)
